import { IJobStateInfoData, JobStateInfoRecord, jobStateInfoFromJSON } from "common/records/JobState/JobStateInfo";
import { List, Record, Map } from "immutable";

export const jobStateFromJSON = (json: Partial<IJobStateData>) => {
  const record: IJobStateRecord = { ...(json as any) };

  if (json.states) {
    record.states = List<string>(json.states);
  }

  if (json.state_info) {
    record.state_info = Map<string, JobStateInfoRecord>();
    Object.keys(json.state_info).forEach((key) => {
      record.state_info = record.state_info.set(
        key,
        jobStateInfoFromJSON((json.state_info as { [key: string]: IJobStateInfoData })[key]),
      );
    });
  }

  return new JobStateRecord(record);
};

export interface IJobStateData {
  states: string[];
  state_info: { [key: string]: IJobStateInfoData };
}

export interface IJobStateRecord {
  states: List<string>;
  state_info: Map<string, JobStateInfoRecord>;
}

export const defaultJobStateRecord = {
  states: List<string>(),
  state_info: Map<string, JobStateInfoRecord>(),
};

export class JobStateRecord extends Record(defaultJobStateRecord) implements IJobStateRecord {}
